/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_main_colors_silver6 = /** @type {(inputs: {}) => string} */ () => {
	return `Stříbrná`
};

const da_main_colors_silver6 = /** @type {(inputs: {}) => string} */ () => {
	return `Sølv`
};

const de_main_colors_silver6 = /** @type {(inputs: {}) => string} */ () => {
	return `Silber`
};

const en_main_colors_silver6 = /** @type {(inputs: {}) => string} */ () => {
	return `Silver`
};

const es_main_colors_silver6 = /** @type {(inputs: {}) => string} */ () => {
	return `Plateado`
};

const fr_main_colors_silver6 = /** @type {(inputs: {}) => string} */ () => {
	return `Argenté`
};

const hu_main_colors_silver6 = /** @type {(inputs: {}) => string} */ () => {
	return `Ezüst`
};

const it_main_colors_silver6 = /** @type {(inputs: {}) => string} */ () => {
	return `Argento`
};

const nl_main_colors_silver6 = /** @type {(inputs: {}) => string} */ () => {
	return `Zilver`
};

const pl_main_colors_silver6 = /** @type {(inputs: {}) => string} */ () => {
	return `Srebrny`
};

const pt_main_colors_silver6 = /** @type {(inputs: {}) => string} */ () => {
	return `Prateado`
};

const sv_main_colors_silver6 = /** @type {(inputs: {}) => string} */ () => {
	return `Silver`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const main_colors_silver6 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.main_colors_silver6(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("main_colors_silver6", locale)
	if (locale === "cs") return cs_main_colors_silver6(inputs)
	if (locale === "da") return da_main_colors_silver6(inputs)
	if (locale === "de") return de_main_colors_silver6(inputs)
	if (locale === "en") return en_main_colors_silver6(inputs)
	if (locale === "es") return es_main_colors_silver6(inputs)
	if (locale === "fr") return fr_main_colors_silver6(inputs)
	if (locale === "hu") return hu_main_colors_silver6(inputs)
	if (locale === "it") return it_main_colors_silver6(inputs)
	if (locale === "nl") return nl_main_colors_silver6(inputs)
	if (locale === "pl") return pl_main_colors_silver6(inputs)
	if (locale === "pt") return pt_main_colors_silver6(inputs)
	return sv_main_colors_silver6(inputs)
};
export { main_colors_silver6 as "main_colors.SILVER" }